var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap010(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 24.5001L3.16675 29.8334V8.50008L12.5001 3.16675M12.5001 24.5001L21.8334 29.8334M12.5001 24.5001V3.16675M21.8334 29.8334L29.8334 24.5001V3.16675L21.8334 8.50008M21.8334 29.8334V8.50008M21.8334 8.50008L12.5001 3.16675",
    stroke: "#4F5B6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap010);
export default __webpack_public_path__ + "static/media/map-010.abde7ad30a0e8a98e32b13a94e6ae3c5.svg";
export { ForwardRef as ReactComponent };